
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandF as ObiOwnShipNoCommandFElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-f.js';
 
 
 

 
 export const ObiOwnShipNoCommandF = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-f',
   elementClass: ObiOwnShipNoCommandFElement,
   events: {
     
   }
  });
 
 